import { Button, Popover, styled } from "@mui/material";

export const ControlsWrapper = styled("div")({
  position: "absolute",
  top: "25px",
  left: "25px",
  zIndex: "100",
});

export const StyledButton = styled(Button)({
  textTransform: "none",
  borderRadius: "16px",
  color: "#1F2025",
  boxShadow: "0px 1px 8px -1px rgba(0, 0, 0, 0.2)",
  padding: "6px 18px",
  background: "white",
  height: "48px",
  fontSize: "16px",
});

export const StyledPopover = styled(Popover)({
  ".MuiPaper-root": {
    marginTop: "8px",
    padding: "10px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
  },
});

export const ListItem = styled("div")(({ choised }: { choised: boolean }) => ({
  minHeight: "10px",
  display: "flex",
  justifyContent: "space-between",
  padding: "14px",
  minWidth: "200px",
  cursor: "pointer",
  background: choised ? "#CFDCFF" : "none",
  borderRadius: "8px",
}));

export const ListItemWrapper = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "5px",
});

export const ActionButtonsWrapper = styled("div")({
  display: "flex",
  gap: "8px",
  marginTop: "8px",
  paddingTop: "8px",
  borderTop: "1px solid #E0E0E0",
});

export const ActionButton = styled("button")({
  flex: 1,
  padding: "8px 16px",
  borderRadius: "8px",
  border: "1px solid #E0E0E0",
  background: "white",
  color: "#2962FF",
  fontSize: "14px",
  fontWeight: "500",
  cursor: "pointer",
  transition: "all 0.2s ease",
  whiteSpace: "nowrap",
  "&:hover": {
    background: "#F5F5F5",
    borderColor: "#2962FF",
  },
  "&:active": {
    background: "#E3F2FD",
  },
});
